/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import styles from './CarouselError.module.scss';

export function CarouselError() {
    return (
        <div
            className={`text-lg p-2 mb-3 color-text-03 text-center ${styles.carouselError}`}
        >
            Sorry, suggestions did‘t load. Please try again later.
        </div>
    );
}
